import { publicKpis } from "@/mocks/publico";

const HERO_BG =
  "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20a%20green%20smart%20city%20with%20abundant%20urban%20trees%2C%20parks%2C%20and%20modern%20buildings%20integrated%20with%20nature%2C%20sunlit%20morning%20light%2C%20bright%20greens%20and%20warm%20tones%2C%20environmental%20sustainability%20concept%2C%20clean%20composition%2C%20professional%20urban%20planning%20photography%20style&width=1600&height=900&seq=publico-hero-2026&orientation=landscape";

export default function PublicHero() {
  return (
    <section id="inicio" className="relative min-h-[620px] md:min-h-[680px] flex flex-col">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55" />

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col justify-center max-w-5xl mx-auto px-4 md:px-6 lg:px-8 w-full text-center pt-20 md:pt-24 pb-8">
        <div className="flex flex-wrap gap-2 justify-center mb-6">
          <span className="px-3 py-1.5 text-xs font-semibold bg-white/15 text-white border border-white/20 rounded-full whitespace-nowrap">CTA Público</span>
          <span className="px-3 py-1.5 text-xs font-semibold bg-white/15 text-white border border-white/20 rounded-full whitespace-nowrap">Mapa Ambiental</span>
          <span className="px-3 py-1.5 text-xs font-semibold bg-white/15 text-white border border-white/20 rounded-full whitespace-nowrap">Áreas Verdes</span>
          <span className="px-3 py-1.5 text-xs font-semibold bg-white/15 text-white border border-white/20 rounded-full whitespace-nowrap">Relatórios Públicos</span>
        </div>

        <h1 className="font-bold text-white mb-4 max-w-3xl mx-auto leading-tight"
          style={{
            fontSize: "clamp(1.6rem, 3vw, 2.6rem)",
            textShadow: "0 2px 12px rgba(0,0,0,0.35)",
          }}
        >
          Transparência ambiental para cidades mais verdes
        </h1>

        <p
          className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed"
          style={{ textShadow: "0 1px 6px rgba(0,0,0,0.25)" }}
        >
          Acompanhe dados públicos de arborização urbana, áreas verdes, Unidades de Conservação, projetos ambientais e indicadores do patrimônio verde municipal.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="#mapa"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#mapa")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="px-6 py-3 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Ver mapa ambiental
          </a>
          <a
            href="#indicadores"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#indicadores")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="px-6 py-3 text-sm font-semibold text-white border border-white/40 hover:bg-white/10 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Consultar indicadores
          </a>
        </div>
      </div>

      {/* KPI Strip */}
      <div className="relative z-10 w-full pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {publicKpis.map((kpi) => (
              <div
                key={kpi.label}
                className="rounded-xl p-3 md:p-4"
                style={{
                  background: "rgba(0, 28, 22, 0.45)",
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                  border: "1px solid rgba(255,255,255,0.12)",
                }}
              >
                <div className="flex items-center gap-2.5 mb-1">
                  <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-white/10">
                    <i className={`${kpi.icon} text-white text-sm md:text-base`} />
                  </div>
                  <span className="text-lg md:text-xl font-bold text-white">
                    {kpi.value}
                  </span>
                </div>
                <p className="text-xs text-white/55 pl-[2.75rem] md:pl-[3rem]">
                  {kpi.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="relative z-10 w-full pb-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <p className="text-xs text-white/50 text-center">
            Os dados exibidos são informações públicas disponibilizadas conforme política de transparência do município ou organização responsável.
          </p>
        </div>
      </div>
    </section>
  );
}